import { createAsyncThunk } from '@reduxjs/toolkit';
import client from 'src/clients/http';
import { IPaymentPackageInfo, IProductPackage } from 'src/types/customer';

export const getPackagesByProductId = createAsyncThunk<IProductPackage[], string>(
  'productPackages/getPackagesByProductId',
  async (productId, { rejectWithValue }) => {
    try {
      const productPackages = await client.getPackagesByProductId(productId);
      return productPackages;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

export const createPaymentPackageInfo = createAsyncThunk<
  IPaymentPackageInfo,
  { customerId: string; packageId: string }
>(
  'productPackages/createPaymentPackageInfo',
  async ({ customerId, packageId }, { rejectWithValue }) => {
    try {
      const result = await client.createPaymentPackageInfo(packageId, customerId);
      return result;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);
